export function indiaDay(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}
function calendarDay(value) {
  const text = String(value || '');
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  const local = text.match(/^(\d{2})[/-](\d{2})[/-](\d{4})$/);
  const parts = iso ? [+iso[1], +iso[2], +iso[3]] : local ? [+local[3], +local[2], +local[1]] : null;
  if (!parts) return null;
  const time = Date.UTC(parts[0], parts[1] - 1, parts[2]);
  const date = new Date(time);
  return date.getUTCFullYear() === parts[0] && date.getUTCMonth() === parts[1] - 1 && date.getUTCDate() === parts[2] ? time / 86400000 : null;
}
export function invoiceAge(row, now = new Date()) {
  const date = calendarDay(row.SalesInvDate || row.InvoiceDate || row.InvDate);
  return date === null ? null : calendarDay(indiaDay(now)) - date;
}
export function dueAmount(row) {
  const raw = row.DueAmt;
  const value = Number(String(raw ?? '').replace(/,/g, ''));
  if (raw == null || String(raw).trim() === '' || !Number.isFinite(value)) throw new Error('Outstanding amount missing');
  return value;
}
export const OVERDUE_DAYS = 7; // an unpaid invoice is overdue once it is more than this many days old
export function isOverdueInvoice(row, now = new Date()) {
  return dueAmount(row) > 0 && invoiceAge(row, now) > OVERDUE_DAYS;
}
export function outstandingSummary(rows, now = new Date()) {
  if (!Array.isArray(rows)) throw new Error('Invalid outstanding response');
  let amount = 0, overdueAmount = 0, unknownDates = 0;
  const open = new Set(), overdue = new Set();
  rows.forEach((row, index) => {
    const due = Math.round(dueAmount(row) * 100);
    amount += due;
    const key = row.FKInvoiceID ? `${row.FKInvoiceSrID || ''}:${row.FKInvoiceID}` : row.SalesInvNo || `row:${index}`;
    if (due > 0) {
      open.add(key);
      if (invoiceAge(row, now) === null) unknownDates++;
      else if (isOverdueInvoice(row, now)) { overdue.add(key); overdueAmount += due; }
    }
  });
  return { amount: amount / 100, openCount: open.size, overdueCount: overdue.size, overdueAmount: overdueAmount / 100, unknownDates };
}
export function needsAttention(balance, activity) {
  return balance?.overdueAmount > 0 && activity?.recent_order_count === 0;
}

